/**
 *  @fileOverview Animations module
 *
 *  @author       Aaron Chapman
 *
 */

function AnimationsModule (AOS) {
  let offsetItems = document.querySelectorAll('.base__strongHeading--animateIn')

  this.init = function () {
    Array.from(offsetItems).forEach(offsetItem => {
      offsetItem.setAttribute('data-aos', 'ecu-slide-left')
    })

    AOS.init({
      once: true,
      duration: 1700
    })
  }
}

module.exports = AnimationsModule
